module.exports = __webpack_public_path__ + "media/sub4-6-7.948e94fd.mp4";